module.exports = __webpack_public_path__ + "img/qxyl.6fddfa65.gif";